import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import AllNotes from './pages/AllNotes';
import Editor from './pages/Editor';
import Wishlist from './pages/Wishlist';
import Stats from './pages/Stats';

function App() {
  const [notes, setNotes] = useState(() => {
    const saved = localStorage.getItem('noteonquick_db');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('noteonquick_db', JSON.stringify(notes));
  }, [notes]);

  const addOrUpdateNote = (note) => {
    setNotes(prev => {
      const exists = prev.find(n => n.id === note.id);
      if (exists) return prev.map(n => n.id === note.id ? note : n);
      return [{ ...note, isWishlisted: false }, ...prev];
    });
  };

  const deleteNote = (id) => setNotes(prev => prev.filter(n => n.id !== id));

  const toggleWishlist = (id) => {
    setNotes(prev => prev.map(n => 
      n.id === id ? { ...n, isWishlisted: !n.isWishlisted } : n
    ));
  };

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/all-notes" element={<AllNotes notes={notes} deleteNote={deleteNote} toggleWishlist={toggleWishlist} />} />
          <Route path="/editor" element={<Editor addNote={addOrUpdateNote} />} />
          <Route path="/wishlist" element={<Wishlist notes={notes} deleteNote={deleteNote} toggleWishlist={toggleWishlist} />} />
          <Route path="/stats" element={<Stats notes={notes} />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;